export const VERTICAL_OFFSET_SB_RESP_IMG = Infinity;
export const VERTICAL_OFFSET_RESP_IMG = 2000;
export const HORIZONTAL_OFFSET_RESP_IMG = 300;

export const VERTICAL_OFFSET_MOBILE_IMG = 1500;
export const HORIZONTAL_OFFSET_MOBILE_IMG = 300;
